import React, { useState } from 'react';
import { createRoot } from 'react-dom/client';
import JshModule from '@core/scripts/helper/jsh-module';
import WishlistErrorLayer from "./components/WishlistErrorLayer.jsx";
import ModelContainer from '@core/scripts/components/model-container';

const { moduleScope } = JshModule('wishlist/wishlist-error-modal');

const WishlistErrorModalModule = () => {

    const model = ModelContainer.get("wishlistGlobalModel");
    const [isWishListErrorLayerOpen, setIsWishListErrorLayerOpen] = useState(false);
    const [errorMessage, setErrorMessage] = useState("FALLBACK");
    const open = React.useCallback((event) => {
        const { error } = event.detail || {};
        if (error) {
            setErrorMessage(error);
        }
        setIsWishListErrorLayerOpen(true);
    }, []);


    const close = React.useCallback(() => {
        setIsWishListErrorLayerOpen(false);
    }, []);

    React.useEffect(() => {

        window.addEventListener('wishlist-error-modal:open', open);

        return () => {
            window.removeEventListener('wishlist-error-modal:open', open);
        };
    }, []);

    return (
        <WishlistErrorLayer errorMessage={errorMessage} isWishListErrorLayerOpen={isWishListErrorLayerOpen} close={close} texts={model?.texts} />
    );
};

if (moduleScope instanceof Element) {
    createRoot(moduleScope).render(<WishlistErrorModalModule />);
}
